import { render, staticRenderFns } from "./MSMQPdRes.vue?vue&type=template&id=35f4ccc8&scoped=true&"
import script from "./MSMQPdRes.vue?vue&type=script&lang=js&"
export * from "./MSMQPdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f4ccc8",
  null
  
)

export default component.exports